export default __webpack_public_path__ + "static/media/mf_tv.79819962.svg";